import { createSlice } from '@reduxjs/toolkit';
import { getUser, isSessionValid, setSession, clearSession } from '../Utils/session';

const initialUser = getUser();

const initialState = {
  isAuthenticated: isSessionValid(),
  user: initialUser
    ? { firstName: initialUser.firstName, lastName: initialUser.lastName, email: initialUser.email }
    : null,
  roles: initialUser?.roles || [],
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSucceeded(state, action) {
      const { accessToken, expiresAtUtc, firstName, lastName, email, roles } = action.payload;
      setSession({ accessToken, expiresAtUtc, firstName, lastName, email, roles });
      state.isAuthenticated = true;
      state.user = { firstName, lastName, email };
      state.roles = roles || [];
    },
    loggedOut(state) {
      clearSession();
      state.isAuthenticated = false;
      state.user = null;
      state.roles = [];
    },
  },
});

export const { loginSucceeded, loggedOut } = authSlice.actions;

export const selectAuth = (state) => state.auth;
export const selectRoles = (state) => state.auth.roles;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;

export default authSlice.reducer;
